import { fromPromise } from 'xstate';

import {
  getNearbyLocations,
  getRecentAndNearbyLocations,
  searchByGeo as searchByGeoService,
  searchLocationsByRegion,
} from '../../../services';
import { type BaseLocationRadiusConfig, type PositionCoordinates } from '../../../types';

import type { Client } from 'urql';

// ─────────────────────────────────────────────────────────────────────────────

export const getRecentAndNearbyLocationsActor = fromPromise(
  async ({ input }: { input: InitialLocationsActorInput }) => getRecentAndNearbyLocations(input),
);

export const getNearbyLocationsActor = fromPromise(
  async ({ input }: { input: InitialLocationsActorInput }) => getNearbyLocations(input),
);

export const searchByAreaActor = fromPromise(async ({ input }: { input: SearchByAreaActorInput }) =>
  searchLocationsByRegion({ client: input.client, context: input.context }),
);

export const searchByGeoActor = fromPromise(async ({ input }: { input: SearchByGeoActorInput }) =>
  searchByGeoService({ client: input.client, context: input.context }),
);

// ─── Types ───────────────────────────────────────────────────────────────────

export type SearchContext = {
  searchString: string;
  predictionsSearchQuery: string | undefined;
  currentPosition: PositionCoordinates | undefined;
  baseLocation:
    | {
        latitude: number;
        longitude: number;
        name: string;
        types?: readonly string[];
        bounds?: {
          southwest: { lat: number; lng: number };
          northeast: { lat: number; lng: number };
        };
      }
    | undefined;
  baseLocationRadiusConfig: BaseLocationRadiusConfig;
  searchArea: SearchByAreaContext['searchArea'];
};

type SearchByAreaContext = {
  searchArea: { topLeft: PositionCoordinates; bottomRight: PositionCoordinates } | undefined;
  currentPosition: PositionCoordinates | undefined;
  baseLocation?: SearchContext['baseLocation'];
};

export type InitialLocationsActorInput = {
  client: Client;
  shouldRequestLocationPermission?: boolean;
};

export type SearchByAreaActorInput = {
  client: Client;
  context: SearchByAreaContext;
};

export type SearchByGeoActorInput = {
  client: Client;
  context: SearchContext;
};
